/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'star-fill': {
    width: 26,
    height: 25,
    viewBox: '0 0 26 25',
    data: '<path pid="0" d="M11.625 1.125c.563-1.125 2.156-1.078 2.672 0l3.094 6.234 6.843.985c1.22.187 1.688 1.687.797 2.578L20.11 15.75l1.172 6.797c.188 1.219-1.125 2.156-2.203 1.594l-6.094-3.235-6.14 3.235c-1.078.562-2.39-.375-2.203-1.594l1.171-6.797-4.921-4.828c-.891-.89-.422-2.39.796-2.578l6.891-.985z" _fill="#000"/>'
  }
})
